// @flow

import AppDispatcher from 'PMT/flux/AppDispatcher';

import SessionStore from 'stores/SessionStore';


import PMTApiOrder from 'PMT/api/ApiOrder';
import ApiError from 'PMT/entities/ApiError';

import ActionTypes from 'constants/ActionTypes';

import { OrdersList, OrderSettings } from 'PMT/entities/order';

export default class OrderAction {

  //
  // orders list on going - GET
  //

  static loadOnGoingOrdersList() {
    PMTApiOrder.getOrdersOnGoingForRestaurant(
      SessionStore.getRestaurantId(),
      OrderAction.receiveOrdersListByModificationDate,
      OrderAction.receiveOrdersListByModificationDateError
    );
  }

  static receiveOnGoingOrdersList(ordersList: OrdersList) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.ON_GOING_ORDERS_LISTRESPONSE_SUCCESS,
      ordersList
    });
  }

  static receiveOnGoingOrdersListError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.ON_GOING_ORDERS_LISTRESPONSE_FAILURE,
      apiError
    });
  }

  //
  // orders list - GET
  //

  static loadOrdersListByModificationDate(fromTime: number, toTime: number) {
    PMTApiOrder.getOrdersListByModificationDate(
      SessionStore.getRestaurantId(),
      fromTime,
      toTime,
      OrderAction.receiveOrdersListByModificationDate,
      OrderAction.receiveOrdersListByModificationDateError
    );
  }

  static receiveOrdersListByModificationDate(ordersList: OrdersList, fromTime: number, toTime: number) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_SUCCESS,
      ordersList,
      fromTime,
      toTime
    });
  }

  static receiveOrdersListByModificationDateError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.ORDERS_LIST_BY_MODIFICATION_DATE_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  // orders history list - GET
  //

  static loadOrdersListByDueDate(fromTime: number, toTime: number) {
    PMTApiOrder.getOrdersListByDueDate(
      SessionStore.getRestaurantId(),
      fromTime,
      toTime,
      OrderAction.receiveOrdersListByDueDate,
      OrderAction.receiveOrdersListByDueDateError
    );
  }

  static receiveOrdersListByDueDate(ordersList: OrdersList, fromTime: number, toTime: number) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_SUCCESS,
      ordersList,
      fromTime,
      toTime
    });
  }

  static receiveOrdersListByDueDateError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.GET_ORDERS_LIST_BY_DUE_DATE_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  // order - UPDATE
  //

  static updateOrder(order: Order) {
    PMTApiOrder.putOrder(
      order,
      OrderAction.receiveUpdatedOrder,
      OrderAction.receiveUpdatedOrderError
    );
  }

  static receiveUpdatedOrder(order: Order) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.UPDATE_ORDER_RESPONSE_SUCCESS,
      order
    });
  }

  static receiveUpdatedOrderError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.UPDATE_ORDER_RESPONSE_FAILURE,
      apiError
    });
  }

  //
  // Order settings - GET
  //

  static loadOrderSettings() {
    PMTApiOrder.getOrderSettings(
      SessionStore.getRestaurantId(),
      OrderAction.receiveOrderSettings,
      OrderAction.receiveOrderSettingsError
    );
  }

  static receiveOrderSettings(orderSettings: OrderSettings) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_ORDER_SETTINGS_SUCCESS,
      orderSettings
    });
  }

  static receiveOrderSettingsError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_ORDER_SETTINGS_FAILURE,
      apiError
    });
  }

  //
  // Order settings - UPDATE
  //

  static updateOrderSettings(orderSettings: OrderSettings) {
    PMTApiOrder.putOrderSettings(
      SessionStore.getRestaurantId(),
      orderSettings,
      OrderAction.receiveUpdatedOrderSettings,
      OrderAction.receiveUpdatedOrderSettingsError
    );
  }

  static receiveUpdatedOrderSettings(orderSettings: OrderSettings) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_ORDER_SETTINGS_SUCCESS,
      orderSettings
    });
  }

  static receiveUpdatedOrderSettingsError(apiError: ApiError) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.PUT_ORDER_SETTINGS_FAILURE,
      apiError
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/actions/OrderAction.js